module.exports = __webpack_public_path__ + "static/img/operations06.6119c1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/operations06.png
// module id = Z+h9
// module chunks = 0